const searchModule = {
  state: {
    searchQuery: '',
    searchResults: {},
    filtered: {
      contentTypes: [],
      categories: [],
      sourceCategories: [],
      timePeriods: []
    },
    ordered: null,
    activeTabIndex: 0,
    popular: {
      articles: null,
      locations: null,
      searchTerms: null
    },
    showByggnadsinventering: true
  },
  mutations: {
    setSearchQuery (state, payload) {
      state.searchQuery = payload
    },
    setSearchResults (state, payload) {
      state.searchResults = payload || {}
    },
    setActiveTabIndex (state, payload) {
      state.activeTabIndex = payload
    },
    setTogglebyggnadsinventering (state, payload) {
      state.showByggnadsinventering = payload
    },
    setFilters (state, payload) {
      state.filtered = {
        ...state.filtered,
        ...payload
      }
    },
    setPopular (state, payload) {
      state.popular = {
        ...state.popular,
        articles: payload.articles || state.popular.articles,
        locations: payload.locations || state.popular.locations,
        searchTerms: payload.searchTerms || state.popular.searchTerms
      }
    }
  },
  actions: {
    setSearchQuery (context, payload) {
      context.commit('setSearchQuery', payload)
    },
    setSearchResults (context, payload) {
      context.commit('setSearchResults', payload)
    },
    setActiveTabIndex (context, payload) {
      context.commit('setActiveTabIndex', payload)
    },
    setTogglebyggnadsinventering (context, payload) {
      context.commit('setTogglebyggnadsinventering', payload)
    },
    setFilters (context, payload) {
      context.commit('setFilters', payload)
    },
    setPopular (context, payload) {
      context.commit('setPopular', payload)
    }
  },
  getters: {
    activeTabIndex: (state) => state.activeTabIndex
  }
}

export default searchModule
